/**
 * Live-feeling financial ticker at the top of the hero. Pure CSS
 * marquee — no JS. The data is intentionally generic + flavorful
 * (no real customer numbers) so it reads as illustrative.
 */

const ITEMS = [
  { label: 'Revenue YTD',        value: '¥868.4M',  delta: '+18.4%', tone: 'good' as const },
  { label: 'Burn',               value: '¥21.2M',   delta: '−6.1%',  tone: 'good' as const },
  { label: 'Runway',             value: '14.2 mo',  delta: '+1.1',   tone: 'good' as const },
  { label: 'EU OPEX',            value: '¥48.2M',   delta: '+22.0%', tone: 'warn' as const },
  { label: 'APAC sales',         value: '¥146.5M',  delta: '+14.4%', tone: 'good' as const },
  { label: 'Headcount',          value: '53',       delta: '+5',     tone: 'warn' as const },
  { label: 'Gross margin',       value: '64.3%',    delta: '+0.8pp', tone: 'good' as const },
  { label: 'DSO',                value: '38 days',  delta: '−4',     tone: 'good' as const },
  { label: 'AI · variance run',  value: '$0.0008',  delta: 'R1',     tone: 'mute' as const },
];

export function TickerBar() {
  const dur = '68s';
  return (
    <div
      aria-hidden
      className="relative border-y border-border bg-ink-50/60 dark:bg-ink-950/60 overflow-hidden"
    >
      <div
        className="flex animate-ticker gap-10 whitespace-nowrap py-2.5"
        style={{ ['--ticker-duration' as string]: dur }}
      >
        {[...ITEMS, ...ITEMS].map((it, i) => (
          <span
            key={`${it.label}-${i}`}
            className="inline-flex items-baseline gap-2 text-[11px]"
          >
            <span className="uppercase tracking-[0.18em] text-muted-foreground">{it.label}</span>
            <span className="num text-foreground font-semibold">{it.value}</span>
            <span
              className={
                'num text-[10.5px] ' +
                (it.tone === 'good'
                  ? 'text-emerald-600'
                  : it.tone === 'warn'
                  ? 'text-rose-500'
                  : 'text-muted-foreground')
              }
            >
              {it.delta}
            </span>
            <span className="text-muted-foreground/40">·</span>
          </span>
        ))}
      </div>
      <div className="pointer-events-none absolute inset-y-0 left-0 w-12 bg-gradient-to-r from-background to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-12 bg-gradient-to-l from-background to-transparent" />
    </div>
  );
}
